<template>
  <div style="padding: 20px">
    <el-card class="box-card">
      <div slot="header" class="clearfix">查重上传</div>
      <div style="display: flex">
        <div class="params">
          <div>url:</div>
          <el-input size="small" v-model="params.url" placeholder="url"></el-input>
        </div>
        <div class="params">
          <div>文本:</div>
          <el-input size="small" v-model="params.text" placeholder="text"></el-input>
        </div>
        <div class="params">
          <div>数量:</div>
          <el-input size="small" type="number" v-model="params.count" placeholder="count"></el-input>
        </div>
        <div class="params">
          <div>类型:</div>
          <el-select size="small" v-model="params.type">
            <el-option label="wallpaper" value="wallpaper"></el-option>
          </el-select>
        </div>
        <div class="params" style="margin-left: 30px">
          <el-button size="small" type="primary" @click="search">查询</el-button>
        </div>
      </div>
      <el-upload :on-remove="handleRemove" :file-list="fileList" :http-request="uploadHttpFile" drag action="" multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">支持单独上传和批量上传（文件名不要包含特殊字符）</div>
      </el-upload>
    </el-card>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="clearfix">查重结果(点击跳转到对应资源)</div>
      <div v-for="item in imageList" :key="item.url">
        <div>
          <template v-if="params.text && /^(?!http)/i.test(item.url)">
            <h3>文本</h3>
            <div>
              <h4 style="color: red;">{{ item.url }}</h4>
            </div>
          </template>
          <template v-else>
            <h3>原图</h3>
            <div>
              <img class="previewImg" style="margin-left: 35px" v-lazy="item.url" alt="origin" />
            </div>
          </template>
          <h3>相似图片</h3>
          <div class="resourceContainer">
            <div @click="toResource(itm)" v-for="itm in item.matchResult" :key="itm.url">
              <img class="previewImg" v-lazy="itm.url" alt="origin" />
              <div>
                <strong>相似度：{{ (itm.score * 100).toFixed(2) }}%</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { searchImages } from '../../../api/searchImage'
export default {
  name: 'createResource',
  data() {
    return {
      params: {
        url: '',
        text: '',
        count: 10,
        type: 'wallpaper'
      },
      imageList: [],
      fileList: [],
      loading: false
    }
  },
  computed: {
    urlMap() {
      const data = new Map([
        ['wallpaper', '/resource/wallpaper/info/']
      ])
      return data
    },
    linkUrl() {
      return ({ id, type }) => {
        let url = ''
        let mapData = this.urlMap
        url = mapData.get(type) + id
        return url
      }
    }
  },
  methods: {
    toResource(data) {
      if (data.id) {
        this.$router.push(this.linkUrl(data))
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    search() {
      this.loading = true
      if (this.fileList.length > 0) {
        this.fileList.forEach((e) => {
          this.params.file = e.url
          const data = new FormData()
          Object.entries(this.params).forEach(([key, value]) => {
            data.append(key, value)
          })
          searchImages(data)
            .then((res) => {
              if (res.success) {
                this.imageList.unshift(res.data)
              }
            })
            .finally((e) => {
              this.loading = false
            })
        })
        this.fileList = []
        return
      }
      const data = new FormData()
      Object.entries(this.params).forEach(([key, value]) => {
        data.append(key, value)
      })
      searchImages(data)
        .then((res) => {
          if (res.success) {
            this.imageList.unshift(res.data)
          }
        })
        .finally((e) => {
          this.loading = false
        })
    },
    uploadHttpFile(params) {
      this.fileList.push({ name: params.file.name, url: params.file })
    }
  }
}
</script>

<style scoped>
.previewImg {
  width: 150px;
  cursor: pointer;
}

.params {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.params> :nth-child(1) {
  flex: 1;
  margin-right: 10px;
}

.params> :nth-child(2) {
  flex: 4;
  margin-right: 10px;
}

.resourceContainer {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  justify-items: center;
}

::v-deep .el-upload {
  width: 100% !important;
}

::v-deep .el-upload-dragger {
  width: 100% !important;
}
</style>
